module.exports = __webpack_public_path__ + "img/gif11.2f217ab0.gif";